import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';

function AuthGuard({ permisos, children }) {
    const session = useSelector((state) => state.session);
    const history = useHistory();

    useEffect(() => {
        if (!session.loggedIn) {
            history.push('/auth/login');
            return;
        }
        if (permisos && permisos !== '' && session.user.permisos && !session.user.permisos.includes(permisos)) {
            history.push('/errors/error-401');
        }
    }, [history, permisos, session.loggedIn, session.user]);

    if (!session.loggedIn) {
        history.push('/auth/login');
        window.location.reload();
    }

    return <>{children}</>;
}

export default AuthGuard;
